/* 商户-模块API */

import { GET, POST, download, uploading, POSTFormData } from '@/request/http'

//商户管理
export const pageBusinessManage = p => POST('/business/business/pagebusinessmanage', p)
//店铺
export const pageShopManage = p => POST('/business/shop/pageshopmanage', p)
//修改店铺押金
export const updateShopDeposit = p => POST('/business/shop/updateshopdeposit', p)
//会员管理
export const pageMemberManage = p => POST('/business/member/pagemembermanage', p)

export const listbusiness = p => POST('/business/business/listbusiness', p)
export const listshop = p => POST('/business/shop/listshop', p)

//我的商户
export const getMyBusinessInfo = p => POST('/business/business/getmybusinessinfo', p)
//我的店铺
export const pageMyBusinessShop = p => POST('/business/shop/pagemybusinessshop', p)
//修改商户信息
export const updateBusinessInfo = p => POST('/business/business/updatebusinessinfo', p)
//查当前用户绑定位置信息
export const listLocation = p => POST('/basic/location/list', p)
//新增店铺
export const saveShop = p => POST('/business/shop/saveshop', p)
//删除店铺
export const removeShop = p => POST('/business/shop/removeshop', p)

//商户会员
export const pageMyMember = p => POST('/business/member/pagemymember', p)
//店铺list
export const listShopByBusiness = p => POST('/business/shop/listshopbybusiness', p)
//新增会员
export const saveMember = p => POST('/business/member/savemember', p)
//修改会员
export const updateMember = p => POST('/business/member/updatemember', p)
//删除会员
export const deleteMember = p => POST('/business/member/deletemember', p)
//查会员
export const getMemberByKeyWords = p => POST('/business/member/getmemberbykeywords', p)

//查店员
export const listUserInfo = p => POST('/business/businessuser/listuserinfo', p)

//我的店铺list
export const listMyShopInfo = p => POST('/business/shop/listmyshopinfo', p)

//会员充值
export const recharge = p => POST('/business/account/recharge', p)
//会员消费
export const pay = p => POST('/business/account/pay', p)
//会员消费验证码
export const sendverificationcode = p => POST('/business/account/sendverificationcode', p)
//会员流水明细
export const pageMemberAccountInfo = p => POST('/business/account/pagememberaccountinfo', p)

//数据统计
export const getStatisticsData = p => POST('/business/statistics/getstatisticsdata', p)



// WEBPACK FOOTER //
// ./src/api/modules/business.js